import React from 'react';
import Relay from 'react-relay';

import { Link } from 'react-router';
import { pure } from 'recompose';

type Props = {
  product: Object,
  from?: string,
  listIndex?: number,
};

export function buildProductLocation(slug: string, id: number, from: ?string, listIndex: ?number) {
  return {
    pathname: `/products/${slug}`,
    state: {
      productId: id,
      from,
      listIndex,
    },
  };
}

const ProductLink = ({product, from, relay, listIndex, ...props}: Props) => (
  <Link to={buildProductLocation(product.slug, product.publicId, from, listIndex)} {...props} />
);

export default Relay.createContainer(pure(ProductLink), {
  fragments: {
    product: () => Relay.QL`
      fragment on Product {
        publicId
        slug
      }
    `,
  },
});



// WEBPACK FOOTER //
// ../src/client/apps/shops/links/ProductLink.js